import { create } from "zustand";
import type { WsMessage } from "../types";

type Handler = (msg: WsMessage) => void;

interface WsState {
  connected: boolean;
  handlers: Set<Handler>;
  setConnected: (c: boolean) => void;
  subscribe: (h: Handler) => () => void;
  emit: (msg: WsMessage) => void;
}

export const useWsStore = create<WsState>((set, get) => ({
  connected: false,
  handlers: new Set(),
  setConnected: (connected) => set({ connected }),
  subscribe: (h) => {
    const s = get();
    s.handlers.add(h);
    return () => s.handlers.delete(h);
  },
  emit: (msg) => {
    const s = get();
    s.handlers.forEach((h) => {
      try {
        h(msg);
      } catch {
        // ignore
      }
    });
  },
}));
